export default __webpack_public_path__ + "static/media/1.dac5a863.webp";